var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { Component, Vue, Prop } from 'vue-property-decorator';
import PageHeader from '@/components/page-header/PageHeader';
import { School as SchoolModel } from '@/models/School';
import { identifyApplication, identifyAppHostname } from '@/support/Client';
import { fileToBase64 } from '@/support/String';
import LoaderCard from '@/components/loader-card/LoaderCard';
let SchoolProfile = class SchoolProfile extends Vue {
    constructor() {
        super(...arguments);
        this.isEditing = false;
        this.isLoading = false;
        this.appHostname = `.${identifyAppHostname()}`;
        this.settings = {
            address_street: '',
            address_number: '',
            address_addition: '',
            address_zip_code: '',
            address_city: '',
            contact_name: '',
            contact_phone: '',
            locale: '',
            avatar: '',
            avatar_small: '',
            email: '',
        };
        this.originalSettings = {
            address_street: '',
            address_number: '',
            address_addition: '',
            address_zip_code: '',
            address_city: '',
            contact_name: '',
            contact_phone: '',
            locale: '',
            avatar: '',
            avatar_small: '',
            email: '',
        };
    }
    toggleEditMode(canceled = false) {
        this.isEditing = !this.isEditing;
        if (canceled) {
            this.settings = { ...{}, ...this.originalSettings };
        }
    }
    parseSettings() {
        this.school.settings = new SchoolModel().dataToModel({}, 'Setting', this.school.settings);
        if (!this.school.settings) {
            return;
        }
        this.school.settings.forEach((setting) => {
            if (this.settings[setting.key] === undefined) {
                return;
            }
            this.settings[setting.key] = setting.value;
        });
        if (identifyApplication() === this.school.id) {
            this.$store.dispatch('loadedSettings', this.school.settings);
        }
        this.originalSettings = { ...{}, ...this.settings };
    }
    avatarChanged(event) {
        if (event.target === null || event.target.files === null || !event.target.files.length) {
            return;
        }
        const file = event.target.files[0];
        fileToBase64(file).then((encodedFile) => {
            this.settings.avatar = encodedFile;
            this.update();
        });
    }
    createSettings() {
        const settings = [];
        Object.keys(this.settings).forEach((key) => {
            const setting = {
                key,
                value: this.settings[key],
            };
            settings.push(setting);
        });
        return settings;
    }
    update() {
        this.school.settings = this.createSettings();
        this.school
            .include('settings')
            .update()
            .then((school) => {
            this.school = school;
            this.parseSettings();
            this.toggleEditMode();
            this.updateSchool();
        });
    }
    mounted() {
        this.initialize();
    }
    initialize() {
        this.isLoading = true;
        this.parseSettings();
        this.isLoading = false;
    }
    updateSchool() {
        this.$emit('update:school', this.school);
    }
};
__decorate([
    Prop({ required: true }),
    __metadata("design:type", typeof (_a = typeof SchoolModel !== "undefined" && SchoolModel) === "function" ? _a : Object)
], SchoolProfile.prototype, "school", void 0);
SchoolProfile = __decorate([
    Component({
        components: {
            PageHeader,
            LoaderCard,
        },
    })
], SchoolProfile);
export default SchoolProfile;
